module.exports = __webpack_public_path__ + "media/38.03c4b3ff.mp3";